

export class AppRecentModelBase {
    userEntityId!: number;
    appCode!: string;


    static from(data: AppRecentModel): AppRecentModelBase {
        let current = new AppRecentModelBase();
        Object.assign(current, data);
        return current;
    }  


}


export interface AppRecentModel extends AppRecentModelBase{}